/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';
import { fetchOntologyAppsTotal } from '@coze-common/ontology';

export function useOntologyAppsCount() {
  const query = useQuery({
    queryKey: ['ontology-apps-count'],
    queryFn: fetchOntologyAppsTotal,
    staleTime: 60 * 1000,
    retry: 1,
  });

  return useMemo(
    () => ({
      count: query.data ?? 0,
      loading: query.isLoading,
      error: query.error,
    }),
    [query.data, query.isLoading, query.error],
  );
}
